/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the account module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  SET_PATIENT: null,

  RESET_PATIENT_PROGRESS: null,

  FETCH_PATIENT_PROGRESS_LIST: null,
  FETCH_PATIENT_PROGRESS_LIST_SUCCESS: null,
  FETCH_PATIENT_PROGRESS_LIST_FAIL: null,

  FETCH_PATIENT_PROGRESS: null,
  FETCH_PATIENT_PROGRESS_SUCCESS: null,
  FETCH_PATIENT_PROGRESS_FAIL: null,

  FETCH_PATIENT_PROGRESS_BY_CYCLE: null,
  FETCH_PATIENT_PROGRESS_BY_CYCLE_SUCCESS: null,
  FETCH_PATIENT_PROGRESS_BY_CYCLE_FAIL: null
});
